import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { CertificateAnprClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.CertificatoPostazioneAnprQuery],
  create: [SystemAuthorizations.CertificatoPostazioneAnprAdd],
  edit: [SystemAuthorizations.CertificatoPostazioneAnprUpdate],
  delete: [SystemAuthorizations.CertificatoPostazioneAnprDelete],
});

export const validationSchemaFilter = yup.object({});

export const headCells: HeadCell<CertificateAnprClient, keyof CertificateAnprClient>[] = [
  {
    id: 'codeAnpr',
    label: 'ID certificato',
  },
  {
    id: 'alias',
    label: 'Alias',
  },
  {
    id: 'startValidityDate',
    label: 'Data inizio validità',
  },
  {
    id: 'endValidityDate',
    label: 'Data fine validità',
  },
  {
    id: 'operatorCode',
    label: 'Cod. Oper.',
  },
  {
    id: 'operatorName',
    label: 'Nome Operatore',
  },
  {
    id: 'action',
    label: '',
  },
];
